var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxSavings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.04 58.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.12,40.63v5.8h5.8v-5.8h2.9c4.01,0,7.25-3.25,7.25-7.26s-3.25-7.25-7.25-7.25h-11.61c-.8,0-1.45-.65-1.45-1.45s.65-1.45,1.45-1.45h15.96v-5.8h-7.26v-5.8h-5.8v5.8h-2.9c-4.01,0-7.25,3.25-7.25,7.25s3.25,7.26,7.25,7.26h11.61c.8,0,1.45,.65,1.45,1.45s-.65,1.45-1.45,1.45h-15.96v5.8h7.25Zm2.9,17.41C12.99,58.04,0,45.04,0,29.02S12.99,0,29.02,0s29.02,12.99,29.02,29.02c-.02,16.02-13,29-29.02,29.02",
    style: {
      fill: "#c42032"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxSavings);
export default __webpack_public_path__ + "static/media/TaxSavings.a1ae73adaa87b861b44610ddf70df155.svg";
export { ForwardRef as ReactComponent };